'use client'
import React from 'react'

import type { CurrentUser } from '@/lib/supabase/auth/get-current-user'
import type { PageType } from '@/types/nav-types'

export interface ClientContextValue {
  pageType: PageType
  // Tri-state: undefined = /api/me hasn't resolved yet, null = signed out,
  // CurrentUser = signed in. Auth-state UI must distinguish loading from
  // signed-out to avoid flicker (e.g. footer briefly showing "Sign In" for
  // a signed-in user while /api/me round-trips).
  user: CurrentUser | null | undefined
}

export const ClientContext = React.createContext<ClientContextValue>({
  pageType: 'story' as PageType,
  user: undefined,
})
